export default __webpack_public_path__ + "static/media/blue-report-icon.6132caae.svg";